module.exports = __webpack_public_path__ + "fj.6503b5caef3c1a3266af.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/fj.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/fj.svg
// module chunks = styles